import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';

const SetUrlPromoCode =
  (repository: StoragePromoCodeRepository) =>
  (value: string | undefined | null): void => {
    if (value) repository.setPromoUrl(value);
  };

export {SetUrlPromoCode};
